/** Functions depending on screen width */
jQuery(document).ready(function ($) {
  function screenDeps($win) {
    /** Above 552px */
    if ($win.width() > 553) {
      if ($(".woocommerceSingle__products").hasClass("slick-initialized")) {
        $(".woocommerceSingle__products").slick("unslick");
      }
      if ($(".blogSingle__products-grid").hasClass("slick-initialized")) {
        $(".blogSingle__products-grid").slick("unslick");
      }
    }
    /** Below 552 px */
    if ($win.width() <= 552) {
      /** Toggle opening footer widgets */
      $(".footer__title").click(function () {
        $(this).toggleClass("open");
        $(this).parent().find(".footer__widget-content").slideToggle();
      });
      /** Toggle opening category tree widget */
      $(".categorytree__title").click(function () {
        $(this).toggleClass("open");
        $(this).closest(".categorytree__widget").find(".categorytree__content").slideToggle();
      });
      /** Toggle opening sidebar */
      $(".sidebar__header").click(function () {
        $(this).toggleClass("open");
        $(this).parent().find(".sidebar__widget").slideToggle();
      });
      /** Toggle opening 'My Account' navigation */
      $(".woocommerceAccount__nav-toggle").click(function () {
        $(this).toggleClass("open");
        $(this).parent().find(".woocommerceAccount__nav-menu").slideToggle();
      });

      /** Products slider */
      $(".woocommerceSingle__products").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
      $(".blogSingle__products-grid").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    }

    /** Above 992px */
    if ($win.width > 993) {
      if ($(".woocommerceSingle__gallery-slider").hasClass("slick-initialized")) {
        $(".woocommerceSingle__gallery-slider").slick("unslick");
      }
      if ($(".woocommerceSingle__gallery-thumbnails").hasClass("slick-initialized")) {
        $(".woocommerceSingle__gallery-thumbnails").slick("unslick");
      }
    }
    /** Below 992px */
    if ($win.width() <= 992) {
      $(".woocommerceSingle__gallery-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight: true,
        asNavFor: ".woocommerceSingle__gallery-thumbnails",
      });
      $(".woocommerceSingle__gallery-thumbnails").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: ".woocommerceSingle__gallery-slider",
        centerMode: true,
        centerPadding: "0",
        focusOnSelect: true,
      });
    }
  }
  screenDeps($(window));
});
